import { useTranslation } from 'react-i18next';
import { Box, EnergyRatingIndicator } from 'enova-frontend-components';
import React, { FC } from 'react';

import { Energimerke, Energimerkeversjon } from '../../../../../../../../types/energimerke';

interface EnergyGradeCellProps {
  energimerke?: Energimerke;
}

export const EnergyGradeCell: FC<EnergyGradeCellProps> = ({ energimerke }) => {
  const { t } = useTranslation();

  if (energimerke?.version === Energimerkeversjon.V2025) {
    throw new Error('Energimerke V2025 not supported in Enova søknad');
  }

  if (!energimerke?.energikarakter || !energimerke.oppvarmingskarakter) {
    return (
      <Box display="flex" justifyContent="center">
        <EnergyRatingIndicator />
      </Box>
    );
  }

  return (
    <Box
      display="flex"
      justifyContent="center"
      title={`${t('energyLabel.heatingGrade', {
        context: energimerke.oppvarmingskarakter
      })} ${energimerke.energikarakter.toUpperCase()}`}
    >
      <EnergyRatingIndicator energyGrade={energimerke.energikarakter} heatingGrade={energimerke.oppvarmingskarakter} />
    </Box>
  );
};
